import type { FgdsProject } from "@domain/project/fgds-project";
import type { MonitoringProject } from "@domain/project/monitoring-project";
import { BusinessScope } from "@lib/constants/business-scope";

export type ScopedProject = FgdsProject | MonitoringProject;

export function isFgdsProject(project: unknown): project is FgdsProject {
  return typeof project === "object" && project !== null && (project as any).constructor?.businessScope === BusinessScope.FGDS;
}

export function isMonitoringProject(project: unknown): project is MonitoringProject {
  return (
    typeof project === "object" && project !== null && (project as any).constructor?.businessScope === BusinessScope.MONITORING
  );
}

export function isBusinessScope(value: unknown): value is BusinessScope {
  return value === BusinessScope.FGDS || value === BusinessScope.MONITORING;
}
